// extracted by mini-css-extract-plugin
export default {"pied_copyright":"pied-copyright_pied_copyright__AoTGC","nav_link_pied_page":"pied-copyright_nav_link_pied_page__mxj3D"};